module.exports = __webpack_public_path__ + "assets/a1dfb10f352b6d0334a8d17d8d8842c1.mp3";